"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListField = void 0;
const react_1 = __importDefault(require("react"));
const FieldLayout_1 = require("../../../layouts/FieldLayout");
const List_1 = require("../../../List");
const ListField_styles_1 = require("./ListField.styles");
const StackView_1 = require("../../../StackView");
const ListField = ({ label, selected, valueGetter, iconGetter, textGetter, comparator, disabled, dataItems, onDoubleClick, cellRenderer, onChange, hasSelectionHeader, texts }) => {
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.lastFill, gap: StackView_1.STACK_GAP.xs },
        react_1.default.createElement(FieldLayout_1.Label, { disabled: disabled }, label),
        react_1.default.createElement(ListField_styles_1.StyledListFieldWrapper, null,
            react_1.default.createElement(List_1.List, { selectionMode: List_1.SELECTION_MODE.multi, hasSelectionHeader: hasSelectionHeader, disabled: disabled, texts: { empty: (texts === null || texts === void 0 ? void 0 : texts.empty) || '' }, cellRenderer: cellRenderer, data: dataItems, selected: selected, valueGetter: valueGetter, onDoubleClick: onDoubleClick, iconGetter: iconGetter, textGetter: textGetter, comparator: comparator, onChange: onChange }))));
};
exports.ListField = ListField;
//# sourceMappingURL=ListField.js.map